import { CreateTagBody, TBusiness, TagRecord } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function postCreateBusinessTag({
  businessId,
  tagRecord,
}: {
  businessId: TBusiness["business_id"];
  tagRecord: CreateTagBody;
}): Promise<TrystGenericResponse<TagRecord>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify(tagRecord);

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
      credentials: "include",
      mode: "cors",
    };

    const response = await fetch(
      `${TRYST_HOST}/business/${businessId}/tag`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    // console.error(error);
    return { success: false };
  }
}
